function addQP(path) {
  if (path.indexOf('?') > 0) {
    path = path + '&';
  } else {
    path = path + '?';
  }

  return path + 'uqs=zoom';
}

export class BackgroundToProjectImageAdapter {
  constructor(background) {
    let newBackground = Object.assign({}, background, {
      thumbPath: addQP(background.thumb_url || background.thumbPath),
      workPath: addQP(background.file_url || background.workPath),
      highResPath: addQP(
        background.hires_url || background.file_url || background.workPath,
      ),
    });

    this.imageID = background.imageID || background.id;
    this.dateTaken = '';
    this.dateLastModified = '';
    this.missingImage = 0;
    this.serverImage = 1;
    this.bucket = background.bucket;
    this.thumbPath = newBackground.thumbPath;
    //this.thumbPath += this.thumbPath.concat("?uqs=zoom");
    this.workPath = newBackground.workPath;
    //this.workPath = this.workPath.concat("uqs=zoom");
    this.highResPath = newBackground.highResPath;
    //this.highResPath = this.highResPath.concat("?uqs=zoom");
    this.orientation = '0';
    this.height = background.imageHeight;
    this.width = background.imageWidth;
    this.imageType = 'n';
    this.notes = '';
    this.filename = '';
    this.linkURL = 'null';
    this.showInMediaTray = 'false';
  }
  toObject() {
    return {
      imageID: this.imageID,
      serverImage: this.serverImage,
      thumbPath: this.thumbPath,
      workPath: this.workPath,
      highResPath: this.highResPath,
      orientation: this.orientation,
      height: this.height,
      width: this.width,
      imageType: this.imageType,
    };
  }
}
